// FAQ accordion grid: categories and questions open and close with their <button>, one at a
// time per group. The open state is the .faq-open class; the animation is in the CSS.
//
// This is the version the staging theme served on 2026-10-20. It existed only in Shopify and
// never reached the repo, so the live theme still ran an older script written for
// <details>/<summary>, which found no <summary> in the button markup and opened nothing.
document.addEventListener('DOMContentLoaded', function () {
  function setOpen(el, open) {
    el.classList.toggle('faq-open', open);
    var summary = el.querySelector(':scope > button');
    if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function isOpen(el) {
    return el.classList.contains('faq-open');
  }

  document.querySelectorAll('.faq-section').forEach(function (section) {
    section.querySelectorAll('.faq-grid').forEach(function (grid) {
      var items = grid.querySelectorAll(':scope > .faq-item');
      items.forEach(function (item) {
        var button = item.querySelector(':scope > button');
        button.addEventListener('click', function () {
          var willOpen = !isOpen(item);
          items.forEach(function (other) {
            setOpen(other, other === item ? willOpen : false);
          });
        });
      });
    });

    var categories = section.querySelectorAll('.faq-categories > .faq-category');
    categories.forEach(function (category) {
      var button = category.querySelector(':scope > button');
      button.addEventListener('click', function () {
        var willOpen = !isOpen(category);
        categories.forEach(function (other) {
          setOpen(other, other === category ? willOpen : false);
        });
      });
    });
  });
});
